module.exports = __webpack_public_path__ + "static/media/design2.86c1c95e.jpg";